var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-2",attrs:{"elevation":"4","width":"990"}},[_c('v-card-text',[_c('h4',{staticClass:"my-3 font-weight-regular"},[_vm._v("Série:")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }